import { parseInBetweenPlayoutSegmentId } from '@/helpers/flow-control-in-between-playout.helper';

/** Synthetic id for narrow slot-assets inline panel under the flow start row (moderators + flow media). */
export const FLOW_SLOT_ASSETS_INLINE_FLOW_START_ID = '__flow_start_slot_assets__';
export const FLOW_SLOT_ASSETS_INLINE_FLOW_END_ID = '__flow_end_slot_assets__';

/** Control tab: expandable pre-flow / after-flow playout segment rows (pre_flow+flow_intro / flow_outro+after_flow). */
export const FLOW_CONTROL_PRE_FLOW_PLAYOUT_ID = '__flow_pre_flow_playout__';
export const FLOW_CONTROL_AFTER_FLOW_PLAYOUT_ID = '__flow_after_flow_playout__';

/** Flow-level control expand ids (not tied to a single slot row id). */
export function isFlowControlFlowLevelMediaExpandId(activeSlotId: string): boolean {
  if (
    activeSlotId === FLOW_CONTROL_PRE_FLOW_PLAYOUT_ID ||
    activeSlotId === FLOW_CONTROL_AFTER_FLOW_PLAYOUT_ID ||
    activeSlotId === FLOW_SLOT_ASSETS_INLINE_FLOW_START_ID ||
    activeSlotId === FLOW_SLOT_ASSETS_INLINE_FLOW_END_ID
  ) {
    return true;
  }
  return parseInBetweenPlayoutSegmentId(activeSlotId) !== null;
}
